import React from "react";
import Header from "../../components/common/Header";
import LoginForm from "../../components/Login/LoginForm";
import SideImage from "../../components/Signup/SideImage";

const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex flex-col lg:flex-row flex-1">
        <SideImage />
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;